import { FC, JSX } from 'react';

import Logo from './logo.svg';
import styles from './SmallLogo.module.scss';

type Props = Omit<JSX.IntrinsicElements['img'], 'src'>;

export const SmallLogo: FC<Props> = ({ alt, className, ...props }) => (
  <img
    {...props}
    src={Logo.src}
    className={className || styles.image}
    alt={alt || 'Catawiki'}
  />
);
